KMVP.partnerInformation = {

    /**
     * @returns {boolean} true if the partner information is mandatory for the selected legal form
     */
    isPartnerInformationRequired: function () {
        var $registrationForm = $('#registrationForm'),
            $legalForm = $registrationForm.find('#legalForm'),
            $partnerInformation = $registrationForm.find('.js-registration-partner-information');

        if (!$partnerInformation.length) {
            return false;
        }

        var legalForms4PartnerInformation = $partnerInformation.data('legal-forms').split(',');
        return arrayContains(legalForms4PartnerInformation, $legalForm.val());
    },

    /**
     * Special handling for the 'Partner Information'-Area in register form (KMVP-3196)
     */
    initPartnerInformation: function () {
        var _this = this,
            $registrationForm = $('#registrationForm'),
            $legalForm = $registrationForm.find('#legalForm'),

            // partner info elements
            $partnerInformation = $registrationForm.find('.js-registration-partner-information'),
            $partnerInformationHeadline = $partnerInformation.find('.js-registration-partner-headline'),
            $partnerInformationEntries = $partnerInformation.find('.js-registration-partner-information-entries'),
            $partnerInfoTemplate = $partnerInformation.find('.js-partner-info-template'),

            // dynamic properties
            index = getRealCount(),
            maxPartners = 3;

        /**
         * Returns the count of the currently visible partner info forms
         */
        function getRealCount() {
            return $partnerInformationEntries.find('.js-registration-partner-information-entry').length;
        }

        /**
         * Refreshes the size of the colorbox
         */
        function resizeColorbox() {
            $.colorbox.resize();
            setTimeout(function () {
                KMVP.overlays.setColorBoxFixedPosition(true); // because box size is dynamic
                $.colorbox.resize();
            }, 500);
        }

        /**
         * Adds a new partner info
         */
        function addEntry() {
            if (getRealCount() >= maxPartners) {
                return; // no more entries
            }

            $partnerInformationEntries.append($.templates('.js-partner-info-template').render({index: index++}));

            refreshButtons();
            resizeColorbox();
        }

        /**
         * Refresh the 'add partner' / 'delete partner' buttons
         */
        function refreshButtons() {
            var $deletePartner = $partnerInformation.find('.js-delete-partner'),
                $addPartner = $partnerInformation.find('.js-add-partner');
            var selectedLegalForm = ($legalForm.val() || '').toString().toLocaleLowerCase();

            if (getRealCount() > 1) {
                $deletePartner.show();
            } else {
                $deletePartner.hide();
                if(selectedLegalForm == 'uk_sl') {
                    $addPartner.hide();
                }
            }



            $deletePartner.unbind().click(function () {
                $(this).closest('.js-registration-partner-information-entry').remove();
                refreshButtons();
                resizeColorbox();
                scrollToTarget($partnerInformation);
            });

            $addPartner.unbind().hide();
            if(selectedLegalForm != 'uk_sl') {
                if (getRealCount() < maxPartners) {
                    $addPartner.last().show().unbind().click(function (e) {
                        e.preventDefault();
                        addEntry();
                    });
                }
            }
        }

        /**
         * Refresh the partner information area
         */
        function refreshPartnerInformationArea() {
            if (!_this.isPartnerInformationRequired()) {
                // selected legal form does not require partner info
                $partnerInformation.hide();
                resizeColorbox();
                return;
            }

            // update headline
            var selectedLegalForm = ($legalForm.val() || '').toString().toLocaleLowerCase();
            $partnerInformationHeadline.text($partnerInformationHeadline.data('headline-' + selectedLegalForm));

            // safely show
            $partnerInformation.removeClass('hide').show();

            // generate the first entry
            if (getRealCount() === 0) {
                addEntry();
            }

            resizeColorbox();
            refreshButtons();
        }

        if ($partnerInformation.length) {
            $legalForm.off('change.partnerinfo').on('change.partnerinfo', function () {
                refreshPartnerInformationArea();
            });

            refreshPartnerInformationArea();
        }

    }


};
